import React, { useState } from 'react';
import './Portfolio.css';
import Mockup from '../../assets/imgs/Site Editora (1).png';
import DownloadPopup from "./DownloadPopup";

const PDF_LINK = 'https://insigneacademica.com.br/api/get-pdf';

async function downloadPDF(setDownloadMessage, setShowPopup) {
  try {

    setDownloadMessage("Seu download começará em instantes. Verifique sua pasta de downloads.");

    setShowPopup(true);
    const response = await fetch(PDF_LINK);

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'portfolio.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  } catch (error) {
    console.error("Error downloading PDF:", error.message);
    setDownloadMessage("Ocorreu um erro ao tentar baixar o portfólio. Por favor, tente novamente.");
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  }
}

function Portfolio() {
  const [downloadMessage, setDownloadMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="portfolio-wrapper">
      <div className='portfolio-container'>
        <h2>Você quer publicar sua obra?</h2>
        <h3>Confira o Portfólio completo da Insigne Acadêmica Editora</h3>
        <img src={Mockup} alt='mockup insigne'></img>
        <div className="btn-container">
          <button onClick={() => downloadPDF(setDownloadMessage, setShowPopup)} className='main-btn'>
            Clique aqui para baixar!
          </button>
        </div>
      </div>
      <DownloadPopup message={downloadMessage} showPopup={showPopup} />
    </div>
  );
}

export default Portfolio;
